// This file is auto-generated by scripts/generate-build-info.mjs. Do not edit manually.
export const buildVersion = '0.0.1';
export const buildCommitId = '3ea0be25';
